namespace Controlli {
    export namespace ToastUI {

        export let ElencoDati: Set<DatiToast>;
        let DatiSeries: object;

        export function Inizialize() {
                  
            const el = document.getElementById('chart-area');
            
            let jsonResult = JSON.stringify({bho: el.dataset.istanza});
            
            const data = {
                categories: ['Browser'],
                series: [
                    {
                        name: 'Chrome',
                        data: 46.02,
                    },
                    {
                        name: 'IE',
                        data: 20.47,
                    },
                    {
                        name: 'Firefox',
                        data: 17.71,
                    },
                    {
                        name: 'Safari',
                        data: 5.45,
                    },
                    {
                        name: 'Opera',
                        data: 3.1,
                    },
                    {
                        name: 'Etc',
                        data: 7.25,
                    }
                ]
            }
            const options = {
                exportMenu: {
                    visible: false
                },
                chart: { height: 310 },
                series: {
                    dataLabels: {
                        visible: false,
                        useSeriesColor: false,
                        pieSeriesName: {
                            visible: false,
                        },
                        callout: {
                            useSeriesColor: false
                        }
                    },
                },
            };
            let chart = toastui.pieChart({ el, data, options });

        }
    }

    interface DatiToast {
        name: string;
        data: number;
    }
}